export default () => {
  document.cookie = "u=; expires=Thu, 01 Jan 1970 00:00:01 GMT;";
  window.location.href = "https://www.hoopla.no";
};
